import {request, _urlBlogTypes} from "../api";
import {BLOG_TYPES_CONSTS} from "../constants";
import {history} from "../../configs/history";
import {notificationSuccess} from "../../components/uiElements/Notifications";

export const GetBlogTypes = () => {
    const requestData = {
        url: _urlBlogTypes,
        token: true,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: BLOG_TYPES_CONSTS.GET_BLOG_TYPES,
                    payload: data
                });
            })
    }
};

export const DeleteBlogTypesById = id => {
    const requestData = {
        url: `${_urlBlogTypes}/${id}`,
        token: true,
        method: "DELETE",
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: BLOG_TYPES_CONSTS.DELETE_BLOG_TYPES_BY_ID,
                    payload: id
                });
            })
    }
};

export const CreateBlogTypes = data => {
    const requestData = {
        url: _urlBlogTypes,
        token: true,
        method: "POST",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: BLOG_TYPES_CONSTS.CREATE_BLOG_TYPES,
                    payload: res?.data
                });
                notificationSuccess({
                    description: "Բլոգի տեսակը հաջողությամբ ստեղծվեց!"
                })
                history.push('/blogTypes')
            })
    }
};

export const UpdateBlogTypesById = (id, data) => {
    const requestData = {
        url: `${_urlBlogTypes}/${id}`,
        token: true,
        method: "PATCH",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: BLOG_TYPES_CONSTS.UPDATE_BLOG_TYPES,
                    payload: res?.data
                });
                notificationSuccess({
                    description: "Բլոգի տեսակը հաջողությամբ փոփոխվեց!"
                })
                history.push('/blogTypes')
            })
    }
};

export const UpdateBlogTypesPositions = items => {
    const requestData = {
        url: _urlBlogTypes,
        token: true,
        method: "PUT",
        data: items
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                notificationSuccess({
                    description: "Բլոգի տեսակը հաջողությամբ փոփոխվեց!"
                })
            })
    }
};
